export default (siteName) => [
    {
        path: 'bank-account',
        name: 'bank-account',
        component: () => import('../../components/dashboard/Finance/BankAccount/index.vue'),
        meta: {
            title: `銀行帳戶${siteName}`,
            activeMenu: 'settings',
        },
    },
    {
        path: 'bank-account/add/',
        name: 'bank-account-add',
        component: () => import('../../components/dashboard/Finance/BankAccount/BankAccountEdit.vue'),
        meta: {
            title: `新增銀行帳戶${siteName}`,
            activeMenu: 'settings',
        },
    },
    {
        path: 'bank-account/:sno/edit/',
        name: 'bank-account-edit',
        component: () => import('../../components/dashboard/Finance/BankAccount/BankAccountEdit.vue'),
        meta: {
            title: `編輯銀行帳戶${siteName}`,
            activeMenu: 'settings',
        },
    },
    {
        path: 'bank-account-detail',
        name: 'bank-account-detail',
        component: () => import('../../components/dashboard/Finance/BankAccount/detailPage.vue'),
        meta: {
            title: `銀行帳戶明細${siteName}`,
            activeMenu: 'settings',
        },
    },
];
